import { Injectable, NgZone } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Subject } from 'rxjs';
//import config from '../../../assets/config.json';
import {environment} from '../../../environments/environment';
@Injectable({
    providedIn: 'root'
})
export class SignalRService {
    private hubConnection: signalR.HubConnection | undefined;
    public notificationReceived = new Subject<any>();

    constructor(private zone: NgZone) { }

    public startConnection = () => {
        if (this.hubConnection && this.hubConnection.state === signalR.HubConnectionState.Connected) {
            return;
        }

        const hubUrl = environment.apiHost.system + '/notificationhub';

        this.hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(hubUrl, {
                accessTokenFactory: () => localStorage.getItem('token') || '',
                transport: signalR.HttpTransportType.LongPolling  // Ocelot không support WebSocket proxy
            })
            .withAutomaticReconnect()
            .build();

        this.hubConnection
            .start()
            .then(() => console.log('Connection started'))
            .catch(err => console.log('Error while starting connection: ' + err));

        this.hubConnection.on('ReceiveNotification', (data) => {
            // Run in NgZone to trigger UI update
            this.zone.run(() => {
                this.notificationReceived.next(data);
            });
        });
    }
}
